import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { MultiDeviceInteractionService } from '../../../services/multi-device-interaction.service';
import { InteractionHowModel, MultiDeviceInteractionState, BulkItemOptions, StandingCharges, SupplyTarrif, SetBulkFriendlyDisconnect, MultiDeviceInteractionModel } from '../../../models/consumer/consumer-interaction.model';
import { getParamFromAncestorRoute } from '../../../utilities/route.utilities';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
import { SiteService } from '../../../services/site.service';
import { ConsumerInteractionService } from '../../../services/consumer-interaction.service';
import { ScreenMessageTemplateModel } from '../../../models/consumer/screen-message-template-list.model';
import * as moment from 'moment';
import { ClaimsService } from '../../../services/claims.service';
import { FriendlyDisconnectResponseModel } from '../../../models/consumer/friendly-disconnect-response.model';

@Component({
    selector: 'multi-device-how',
    templateUrl: './multi-device-how.component.html',
    styles: []
})
export class MultiDeviceHowComponent implements OnInit, OnDestroy {

    form: UntypedFormGroup;
    dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    dateAutoCorrectPipe = createAutoCorrectedDatePipe('dd/mm/yyyy');
    pageTitle: string;
    bulkKey: string;
    bulkState: string;
    sites: any[] = [];

    standingCharges:  StandingCharges[] = [];
    supplyTarrifs:    SupplyTarrif[] = [];
    messageTemplates: ScreenMessageTemplateModel[];
    friendlyDisconnectInteraction: FriendlyDisconnectResponseModel;

    submitted: boolean = false;
    selectedTemplateMessage: string;
    selectedTemplate: string;
    messageLength: number = 0;
    subscriptions: any[] = [];
    clientId: number;
    cachedValue: number;
    cachedMessge: string;

    private numberMask = createNumberMask({
        prefix: '',
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ',',
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 5,
        integerLimit: null,
        requireDecimal: false,
        allowNegative: true,
        allowLeadingZeroes: false
    });

    constructor(
        private fb: UntypedFormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private siteService: SiteService,
        private consumerInteractionService: ConsumerInteractionService,
        private multiDeviceInteractionService: MultiDeviceInteractionService,
        private claimService: ClaimsService
    ) {

        this.form = fb.group({
            'adjustmentAmount': [null, Validators.required],
            'emergencyCreditLimitAmount': [null, Validators.required],
            'newLoanAmount': [null, Validators.required],

            'selectSiteId': [null, Validators.required],

            //supply tarrif
            'supplyTarrifType': [null, Validators.required],
            'supplyTarrifValue': [null, Validators.required],
            'supplyTarrifAmount': [null, Validators.required],

            // standing charge
            'standingChageType': [null, Validators.required],
            'standingChargeValue': [null, Validators.required],
            'standingChargeAmount': [null, Validators.required],

            // friendly disconnect
            'saturdayDisconnect': [null, Validators.required],
            'saturdayStartTime': [null, Validators.required],
            'saturdayEndTime': [null, Validators.required],
            'sundayDisconnect': [null, Validators.required],
            'sundayStartTime': [null, Validators.required],
            'sundayEndTime': [null, Validators.required],
            'weekdayDisconnect': [null, Validators.required],
            'weekdayStartTime': [null, Validators.required],
            'weekdayEndTime': [null, Validators.required],
            'specialDays': [[], null],
            'specialDay': [null, null],

            //screen message
            'message': [this.selectedTemplateMessage, Validators.compose([Validators.required, Validators.maxLength(120)])]
        });
    }

    ngOnInit() {
        this.clientId = getParamFromAncestorRoute(this.route, 'clientId');

        this.consumerInteractionService.getDeviceScreenMessageTemplates(this.clientId).then((messageTemplatesRes) => {
            this.messageTemplates = messageTemplatesRes;

            if (bulkModel.how && bulkModel.how.message) {

                for (let entry of this.messageTemplates) {
                    if (this.cachedMessge === entry.messageText) {
                        this.onChange(entry.messageName);
                    }
                }

                this.messageLength = this.cachedMessge.length;
                this.form.controls.message.setValue(this.cachedMessge);

            } else {
                this.selectedTemplateMessage = this.messageTemplates[0].messageText;
                this.messageLength = this.selectedTemplateMessage.length;
                this.form.controls.message.setValue(this.selectedTemplateMessage);
            }
        })

        let bulkModel = this.multiDeviceInteractionService.getModelMultiDeviceModel;
        this.setFriendlyDisconnectFromCache(bulkModel);

        if (bulkModel.how && bulkModel.how.value) {
            this.cachedValue = bulkModel.how.value;
        }
        if (bulkModel.how && bulkModel.how.message) {
            this.cachedMessge = bulkModel.how.message;
            this.form.get('message').setValue(this.cachedMessge);
        }

        this.siteService.all(this.clientId).then((result) => {
            this.sites = result;
        });

        this.subscriptions.push(this.form.controls.message.valueChanges.subscribe(data => {
            if (data) {
                this.messageLength = data.length;
            }
        }));

        this.setState(bulkModel.what.type.key);

        this.subscriptions.push(this.form.controls['selectSiteId'].valueChanges.subscribe((val) => {
            if (bulkModel.what.type.key == BulkItemOptions.UpdateSupplyTarrifs) {
                this.consumerInteractionService.getSupplyTarrifs(this.clientId, this.form.controls['selectSiteId'].value).then((SupplyTarrifRes) => {
                    this.supplyTarrifs = SupplyTarrifRes;
                }).catch((error) => {
                    console.log("could not get standing charges: " + error);
                });
            }

            if (bulkModel.what.type.key == BulkItemOptions.UpdateStandingCharges) {
                this.consumerInteractionService.getStandingCharges(this.clientId, this.form.controls['selectSiteId'].value).then((standingChargesRes) => {
                    this.standingCharges = standingChargesRes;
                }).catch((error) => {
                    console.log("could not get standing charges: " + error);
                });

            }
        }));
    }

    onAddSpecialDateClick() {
        let m = moment(this.form.value.specialDay, 'DD/MM/YYYY');
        let isValid = m.isValid() && m.isSameOrAfter();
        let currentDate = new Date();

        if (m.year() < currentDate.getFullYear()) { isValid = false; }
        if (m.year() > currentDate.getFullYear() + 2) { isValid = false; }

        if (!isValid) return;
        let values = this.form.value.specialDays;
        let date = m.toISOString();
        if (values.find(x => x.date === date)) return;

        values.push({
            date: date,
            selected: true
        });

        this.form.controls.specialDays.setValue(values);
        this.form.controls.specialDay.setValue("");
    }

    onSpecialDateClick(item: any) {
        let values = this.form.value.specialDays;
        values.find(x => item.date == x.date).selected = !item.selected;
        this.form.controls.specialDays.setValue(values);
    }

    setFriendlyDisconnectFromCache(model: MultiDeviceInteractionModel) {
        if (model && model.how && model.how.friendlyDisconnect) {
            //set friendly disconnect
            let friendlyDisconnect = model.how.friendlyDisconnect;

            this.form.controls['saturdayDisconnect'].setValue(friendlyDisconnect.saturday);
            this.form.controls['sundayDisconnect'].setValue(friendlyDisconnect.sunday);
            this.form.controls['weekdayDisconnect'].setValue(friendlyDisconnect.weekdays);

            this.form.controls['saturdayStartTime'].setValue(friendlyDisconnect.saturdayStartTime);
            this.form.controls['saturdayEndTime'].setValue(friendlyDisconnect.saturdayEndTime);

            this.form.controls['sundayStartTime'].setValue(friendlyDisconnect.sundayStartTime);
            this.form.controls['sundayEndTime'].setValue(friendlyDisconnect.sundayEndTime);

            this.form.controls['weekdayStartTime'].setValue(friendlyDisconnect.weekdayStartTime);
            this.form.controls['weekdayEndTime'].setValue(friendlyDisconnect.weekdayEndTime);

            this.form.controls['specialDays'].setValue(friendlyDisconnect.specialDays);

            this.form.controls.specialDay.markAsDirty();
        }
    }

    setState(bulkKey: string) {

        if (bulkKey == BulkItemOptions.AdjustCreditStatus) {
            this.bulkState = "ajustcredit";
            this.pageTitle = "Adjust credit status by a value";
            this.form.get('adjustmentAmount').setValue(this.cachedValue);
        }

        if (bulkKey == BulkItemOptions.ApplyLoan) {
            this.bulkState = "applyloan";
            this.pageTitle = "Apply a loan";
            this.form.get('newLoanAmount').setValue(this.cachedValue);
        }

        if (bulkKey == BulkItemOptions.ChangeECLimit) {
            this.bulkState = "changeeclimit";
            this.pageTitle = "Change value of emergency credit limit";
            this.form.get("emergencyCreditLimitAmount").setValue(this.cachedValue);
        }

        if (bulkKey == BulkItemOptions.SendScreenMessage) {
            this.bulkState = "sendscreenmessage";
            this.pageTitle = "Screen message";
            this.form.get("message").setValue(this.cachedMessge);
        }

        if (bulkKey == BulkItemOptions.UpdateFriendlyDisconnectSettings) {
            this.bulkState = "updatefriendlydisconnect";
            this.pageTitle = "Update friendly disconnect setting";
        }

        if (bulkKey == BulkItemOptions.UpdateStandingCharges) {
            this.bulkState = "updatestandingcharges";
            this.pageTitle = "Update standing charge value";
            this.form.get('standingChargeAmount').setValue(this.cachedValue);

            this.siteService.all(this.clientId).then((result) => {
                this.sites = result;
                if (this.sites) {
                    this.form.controls['selectSiteId'].setValue(this.sites[0].siteId);
                    this.consumerInteractionService.getStandingCharges(this.clientId, this.form.controls['selectSiteId'].value).then((standingChargesRes) => {
                        this.standingCharges = standingChargesRes;
                    }).catch((error) => {
                        console.log("could not get standing charges: " + error);
                    });
                }
            }).catch((error) => {
                console.log("could not get client sites: " + error);
            });
        }

        if (bulkKey == BulkItemOptions.UpdateSupplyTarrifs) {
            this.bulkState = "updatesupplytariffs";
            this.pageTitle = "Update supply tariff";

            this.form.get("supplyTarrifAmount").setValue(this.cachedValue);

            this.siteService.all(this.clientId).then((result) => {
                this.sites = result;
                if (this.sites) {
                    this.form.controls['selectSiteId'].setValue(this.sites[0].siteId);

                    this.consumerInteractionService.getSupplyTarrifs(this.clientId, this.form.controls['selectSiteId'].value).then((SupplyTarrifRes) => {
                        this.supplyTarrifs = SupplyTarrifRes;
                    }).catch((error) => {
                        console.log("could not get standing charges: " + error);
                    });
                }
            }).catch((error) => {
                console.log("could not get client sites: " + error);
            });
        }
    }

    get isPositiveAmount() {
        let num = this.form.controls.adjustmentAmount.value;
        if (num == null || num == '') return false;
        return +num.replace(/,/g, "") > 0;
    }

    onChange(value) {
        let templateItem = this.messageTemplates.find(x => x.messageName == value);
        if (templateItem) {
            this.selectedTemplateMessage = templateItem.messageText;
            this.messageLength = this.selectedTemplateMessage.length;
            this.selectedTemplate = value;
            this.form.controls.message.setValue(this.selectedTemplateMessage);
            this.form.controls.message.markAsDirty();
        }
    }

    submit(form: UntypedFormGroup) {
        this.submitted = true;
        let hasError = false;
        let howModel = new InteractionHowModel();
        let storedInteractionModel = this.multiDeviceInteractionService.getModelMultiDeviceModel;

        switch (storedInteractionModel.what.type.key) {
            case BulkItemOptions.AdjustCreditStatus:
                howModel.value = form.get("adjustmentAmount").value;
                hasError = this.form.get("adjustmentAmount").hasError("required");
                break;

            case BulkItemOptions.ChangeECLimit:
                howModel.value = form.get("emergencyCreditLimitAmount").value;
                hasError = this.form.get("emergencyCreditLimitAmount").hasError("required");
                break;

            case BulkItemOptions.ApplyLoan:
                howModel.value = form.get("newLoanAmount").value;
                hasError = this.form.get("newLoanAmount").hasError("required");
                break;

            case BulkItemOptions.UpdateSupplyTarrifs:
                howModel.siteId = form.get('selectSiteId').value;
                howModel.value = form.get("supplyTarrifAmount").value;
                howModel.supplyTarrifType = this.supplyTarrifs.find(x => x.tarrifValue == this.form.value.supplyTarrifValue).tarrif;
                howModel.pastValue = Number(this.form.value.supplyTarrifValue);
                hasError = this.form.get("supplyTarrifAmount").hasError("required");
                break;

            case BulkItemOptions.UpdateStandingCharges:
                howModel.siteId = form.get('selectSiteId').value;
                howModel.value = form.get("standingChargeAmount").value;
                howModel.pastValue = form.get("standingChargeValue").value;
                hasError = this.form.get("standingChargeAmount").hasError("required");
                break;

            case BulkItemOptions.SendScreenMessage:
                howModel.message = form.get("message").value;
                hasError = this.form.get("message").hasError("required");
                break;

            case BulkItemOptions.UpdateFriendlyDisconnectSettings:
                // set friendly disconnect settings
                if (!howModel.friendlyDisconnect) {
                    howModel.friendlyDisconnect = new SetBulkFriendlyDisconnect();
                }

                howModel.friendlyDisconnect.saturday = this.form.value.saturdayDisconnect == null || this.form.value.saturdayDisconnect == false ? false : true;
                howModel.friendlyDisconnect.saturdayStartTime = this.form.value.saturdayDisconnect ? this.form.value.saturdayStartTime : null;
                howModel.friendlyDisconnect.saturdayEndTime = this.form.value.saturdayDisconnect ? this.form.value.saturdayEndTime : null;

                howModel.friendlyDisconnect.sunday = this.form.value.sundayDisconnect == null || this.form.value.sundayDisconnect == false ? false : true;
                howModel.friendlyDisconnect.sundayStartTime = this.form.value.sundayDisconnect ? this.form.value.sundayStartTime : null;
                howModel.friendlyDisconnect.sundayEndTime = this.form.value.sundayDisconnect ? this.form.value.sundayEndTime : null;

                howModel.friendlyDisconnect.weekdays = this.form.value.weekdayDisconnect == null || this.form.value.weekdayDisconnect == false ? false : true;
                howModel.friendlyDisconnect.weekdayStartTime = this.form.value.weekdayDisconnect ? this.form.value.weekdayStartTime : null;
                howModel.friendlyDisconnect.weekdayEndTime = this.form.value.weekdayDisconnect ? this.form.value.weekdayEndTime : null;

                howModel.friendlyDisconnect.specialDays = this.form.value.specialDays.map((days) => {
                    return days;
                });

                howModel.friendlyDisconnect.userID = this.claimService.userId;

                hasError = !this.form.get("saturdayDisconnect").hasError("required") &&
                    (!this.form.get("saturdayStartTime").hasError("required") &&
                        !this.form.get("saturdayEndTime").hasError("required"));

                hasError = this.form.get("saturdayDisconnect").hasError("required") &&
                    this.form.get("sundayDisconnect").hasError("required") &&
                    this.form.get("weekdayDisconnect").hasError("required");

                break;
        }

        if (this.form.errors || hasError) return;

        storedInteractionModel.how = howModel;
        window.sessionStorage.setItem('multi-device-interaction', JSON.stringify(storedInteractionModel));

        let currentState = MultiDeviceInteractionState.how;
        let nextState = this.multiDeviceInteractionService.getNextState(currentState);

        this.router.navigated = false;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { state: nextState }
        });
    }

    getSecondsFromMidnight = (time) => {
        let seconds = 0;
        if (!time) return seconds;
        seconds += time.split(':')[0] * 60 * 60;
        seconds += time.split(':')[1] * 60;
        return seconds;
    }

    formatTime24(data: string): string {
        // assuming hh:mm:ss 24 hour format to hh:mm pm/am
        if (!data) { return ""; }
        let timeType = "am"
        let timeParts = data.split(":");
        if (timeParts.length > 2) { timeParts.pop(); }

        if (Number(timeParts[0]) > 12 ||
            (Number(timeParts[0]) == 12 && Number(timeParts[1]) > 0)) {
            timeType = "pm"
        } else { timeType = "am" }

        let result = timeParts.join(":") + timeType;
        return result;
    }

    formatFriendlyDisconnectTimes(model: FriendlyDisconnectResponseModel): FriendlyDisconnectResponseModel {

        model.saturdayStartTime = this.formatTime24(model.saturdayStartTime);
        model.saturdayEndTime = this.formatTime24(model.saturdayEndTime);

        model.sundayStartTime = this.formatTime24(model.sundayStartTime);
        model.sundayEndTime = this.formatTime24(model.sundayEndTime);

        model.weekdayStartTime = this.formatTime24(model.weekdayStartTime);
        model.weekdayEndTime = this.formatTime24(model.weekdayEndTime);

        return model;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
